module.exports = __webpack_public_path__ + "img/pos_tag_0.b6a99490.png";